import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTOPruefungsartListStatus: 'idle',
    loadTOPruefungsartListError: undefined as any,
    loadTOPruefungsartListLastArgs: undefined as any,
    loadTOPruefungsartStatus: 'idle',
    loadTOPruefungsartError: undefined as any,
    saveTOPruefungsartStatus: 'idle',
    saveTOPruefungsartError: undefined as any,
    deleteTOPruefungsartStatus: 'idle',
    deleteTOPruefungsartError: undefined as any,

    tOPruefungsartList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOPruefungsartList = createAsyncThunk('toPruefungsartSlice/loadTOPruefungsartList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toPruefungsartSlice.loadTOPruefungsartListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristopruefungsart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOPruefungsartListStatus } = getState().toPruefungsartSlice
        return loadTOPruefungsartListStatus !== 'pending'
    }
})

export const loadTOPruefungsart = createAsyncThunk('toPruefungsartSlice/loadTOPruefungsart', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristopruefungsart/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOPruefungsartStatus } = getState().toPruefungsartSlice
        return loadTOPruefungsartStatus !== 'pending'
    }
})

export const saveTOPruefungsart = createAsyncThunk('toPruefungsartSlice/saveTOPruefungsart', async ({ tOPruefungsart }: any, { rejectWithValue }: any) => {
    let promises = []
    if (tOPruefungsart?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristopruefungsart/${ tOPruefungsart?.HDR_ID }/`,
            prepareData(tOPruefungsart),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristopruefungsart/`,
            prepareData(tOPruefungsart),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOPruefungsartStatus } = getState().toPruefungsartSlice
        return saveTOPruefungsartStatus !== 'pending'
    }
})

export const deleteTOPruefungsart = createAsyncThunk('toPruefungsartSlice/deleteTOPruefungsart', async ({ selectedIds }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/DeleteTOPruefungsart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: selectedIds.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTOPruefungsartStatus } = getState().toPruefungsartSlice
        return deleteTOPruefungsartStatus !== 'pending'
    }
})

const TOPruefungsartSlice = createSlice({
    name: 'toPruefungsartSlice',
    initialState,
    reducers: {
        resetloadTOPruefungsartListError: (state) => {
            state.loadTOPruefungsartListError = undefined
        },
        resetloadTOPruefungsart: (state) => {
            state.formItem = undefined
            state.loadTOPruefungsartError = undefined
        },
        resetloadTOPruefungsartError: (state) => {
            state.loadTOPruefungsartError = undefined
        },
        resetsaveTOPruefungsart: (state) => {
            state.formItem = undefined
            state.saveTOPruefungsartError = undefined
        },
        resetsaveTOPruefungsartError: (state) => {
            state.saveTOPruefungsartError = undefined
        },
        resetdeleteTOPruefungsartError: (state) => {
            state.deleteTOPruefungsartError = undefined
        },
        removeFromTOPruefungsartListById: (state, action) => {
            state.tOPruefungsartList = state.tOPruefungsartList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromTOPruefungsartListByIds: (state, action) => {
            state.tOPruefungsartList = state.tOPruefungsartList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.tOPruefungsartList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOPruefungsartListStatus = 'preloaded'
            state.loadTOPruefungsartListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.tOPruefungsartList = []
            state.loadTOPruefungsartListStatus = 'idle'
            state.loadTOPruefungsartListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOPruefungsartList.pending, (state) => {
            state.loadTOPruefungsartListStatus = 'pending'
            state.loadTOPruefungsartListError = undefined
        })
        builder.addCase(loadTOPruefungsartList.fulfilled, (state, action) => {
            state.loadTOPruefungsartListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOPruefungsartListLastArgs = action.payload.args

            {
                state.tOPruefungsartList = action.payload.data

            }
        })
        builder.addCase(loadTOPruefungsartList.rejected, (state, action) => {
            state.loadTOPruefungsartListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOPruefungsartListError = action.error.message
            } else {
                state.loadTOPruefungsartListError = action.payload
            }
        })

        builder.addCase(loadTOPruefungsart.pending, (state) => {
            state.loadTOPruefungsartStatus = 'pending'
            state.loadTOPruefungsartError = undefined
        })
        builder.addCase(loadTOPruefungsart.fulfilled, (state, action) => {
            state.loadTOPruefungsartStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOPruefungsartList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOPruefungsartList.push(newItem) }
                else { state.tOPruefungsartList[i] = { ...state.tOPruefungsartList[i], ...newItem } }
            }
        })
        builder.addCase(loadTOPruefungsart.rejected, (state, action) => {
            state.loadTOPruefungsartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOPruefungsartError = action.error.message
            } else {
                state.loadTOPruefungsartError = action.payload
            }
        })

        builder.addCase(saveTOPruefungsart.pending, (state) => {
            state.saveTOPruefungsartStatus = 'pending'
            state.saveTOPruefungsartError = undefined
        })
        builder.addCase(saveTOPruefungsart.fulfilled, (state, action) => {
            state.saveTOPruefungsartStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tOPruefungsartList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tOPruefungsartList.push(newItem) }
                else { state.tOPruefungsartList[i] = { ...state.tOPruefungsartList[i], ...newItem } }
            }
        })
        builder.addCase(saveTOPruefungsart.rejected, (state, action) => {
            state.saveTOPruefungsartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOPruefungsartError = action.error.message
            } else {
                state.saveTOPruefungsartError = action.payload
            }
        })

        builder.addCase(deleteTOPruefungsart.pending, (state) => {
            state.deleteTOPruefungsartStatus = 'pending'
            state.deleteTOPruefungsartError = undefined
        })
        builder.addCase(deleteTOPruefungsart.fulfilled, (state, action) => {
            state.deleteTOPruefungsartStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.tOPruefungsartList = state.tOPruefungsartList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.tOPruefungsartList = state.tOPruefungsartList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTOPruefungsart.rejected, (state, action) => {
            state.deleteTOPruefungsartStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTOPruefungsartError = action.error.message
            } else {
                state.deleteTOPruefungsartError = action.payload
            }
        })

    }
})

export const {
    resetloadTOPruefungsartListError,
    resetloadTOPruefungsart,
    resetloadTOPruefungsartError,
    resetsaveTOPruefungsart,
    resetsaveTOPruefungsartError,
    resetdeleteTOPruefungsartError,
    removeFromTOPruefungsartListById,
    removeFromTOPruefungsartListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = TOPruefungsartSlice.actions
export default TOPruefungsartSlice.reducer
